import { motion } from "framer-motion";
import { HOUSE } from "@/constants/testIds";

const FOUNDER_IMG = "/media/telesa.jpg";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export const Founder = () => {
  return (
    <section
      id="founder"
      data-testid={HOUSE.sectionFounder}
      className="relative bg-[var(--ivory-soft)] text-[var(--ink)] py-28 md:py-36 border-t border-[var(--border-dark)]"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12 md:gap-20 items-center">
        {/* Portrait */}
        <motion.div {...fadeUp} className="md:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-[var(--walnut)]">
            <img
              src={FOUNDER_IMG}
              alt="Telesa Smith Wright — Founder of The House of BorsaLux"
              loading="lazy"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-[var(--gold)]/25" />
          </div>
        </motion.div>

        {/* Bio */}
        <div className="md:col-span-7">
          <motion.p
            {...fadeUp}
            className="font-sans text-[11px] uppercase tracking-[0.5em] text-[var(--gold-dark)] mb-8"
          >
            The Founder
          </motion.p>

          <motion.h2
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.08 }}
            className="font-serif text-[var(--ink)] text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-light"
          >
            Telesa Smith Wright
          </motion.h2>

          <motion.p
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.14 }}
            className="mt-4 font-sans text-sm uppercase tracking-[0.32em] text-[var(--muted-light)]"
          >
            Founder · The House of BorsaLux
          </motion.p>

          <motion.div
            {...fadeUp}
            transition={{ ...fadeUp.transition, delay: 0.22 }}
            className="mt-10 max-w-xl space-y-6 font-sans text-[var(--ink)]/80 leading-relaxed text-base md:text-lg"
          >
            <p>
              Telesa is a business owner, real estate broker, educator, and
              coach. Her practice — across every one of those disciplines — is
              built on the same instinct: noticing overlooked experiences and
              asking whether they could be better.
            </p>
            <p>
              The House of BorsaLux began with an observation she couldn&apos;t
              set aside. Beautiful spaces are designed with extraordinary
              attention to architecture, materials, and light. The simple
              question of where people place the things they carry is often
              left unanswered.
            </p>
            <p>
              She started sketching what an answer might look like — not a
              piece of equipment, but a piece of the room. The Abike Collection
              is the first result.
            </p>
            <p className="text-[var(--ink)] italic font-serif text-lg md:text-xl leading-snug border-l-2 border-[var(--gold)] pl-6 mt-8">
              &ldquo;A well-designed room already respects the person who walks
              into it. It should respect what they bring with them, too.&rdquo;
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
